module.exports = __webpack_public_path__ + "assets/img/auth_back_arrow.svg";